import theme from "@/styles/theme";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  row-gap: 12px;
  @media (${theme.devices.tablet}) {
    row-gap: 12px;
  }
  .section {
    display: flex;
    flex-direction: row;
    column-gap: 1vw;
    @media (${theme.devices.tablet}) {
      display: flex;
      flex-direction: column;
      row-gap: 12px;
    }
  }
  .pair {
    display: flex;
    flex-direction: row;
    column-gap: 1vw;
    @media (${theme.devices.tablet}) {
      column-gap: 12px;
    }
  }
`;
